<template>
  <div class="conversation-showrooms">
    <article v-for="showroom in showrooms" :key="showroom.showroom_id">
      <strong>{{ showroom.name }}</strong>
      <p v-if="showroom.city || showroom.country">
        {{ [showroom.city, showroom.country].filter(Boolean).join(', ') }}
      </p>
      <p v-if="showroom.address">{{ showroom.address }}</p>
      <p v-if="showroom.hours">{{ showroom.hours }}</p>
      <a v-if="showroom.phone" :href="`tel:${showroom.phone}`">{{ showroom.phone }}</a>
    </article>
  </div>
</template>

<script setup lang="ts">
import type { ChatShowroom } from '@/tools/chat_api';

defineProps<{ showrooms: ChatShowroom[] }>();
</script>

<style scoped lang="scss">
.conversation-showrooms {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 20px;

  article {
    padding: 16px;
    border: 1px solid #e8e8e8;
    border-radius: 12px;
    background: #fff;
  }

  p { margin: 5px 0; color: #666; font-size: 14px; }
  a { color: var(--green); text-decoration: none; }
}

@media (max-width: 600px) {
  .conversation-showrooms { grid-template-columns: 1fr; }
}
</style>
